module.exports = __webpack_public_path__ + "img/doors.8907d85e.svg";